export function focusInputGroups(query = document.querySelectorAll('.inputGroup input,.inputGroup select,.inputGroup textarea')) {
    for (let input of query) {
        checkFilledInput(input);
    }

    document.addEventListener("focus", function (e) {
        if (e.target.matches('.inputGroup input, .inputGroup select, .inputGroup textarea')) {
            const inputGroup = e.target.closest(".inputGroup");
            const infieldInputGroup = e.target.closest(".infieldInputGroup");
            if (inputGroup) inputGroup.classList.add("is-focus");
            if (infieldInputGroup) infieldInputGroup.classList.add("is-focus");
        }
    }, true);

    document.addEventListener("blur", function (e) {
        if (e.target.matches('.inputGroup input, .inputGroup select, .inputGroup textarea')) {
            const inputGroup = e.target.closest(".inputGroup");
            const infieldInputGroup = e.target.closest(".infieldInputGroup");
            if (inputGroup) inputGroup.classList.remove("is-focus");
            if (infieldInputGroup) infieldInputGroup.classList.remove("is-focus");
        }
    }, true);

    document.addEventListener("input", function (e) {
        if (e.target.matches('.inputGroup input, .inputGroup select, .inputGroup textarea')) {
            checkFilledInput(e.target);
        }
    }, true);

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(node) {
                if (node.nodeType === 1) {
                    if (node.matches && node.matches('.inputGroup input, .inputGroup select, .inputGroup textarea')) {
                        checkFilledInput(node);
                    }
                    const inputs = node.querySelectorAll && node.querySelectorAll('.inputGroup input, .inputGroup select, .inputGroup textarea');
                    if (inputs) {
                        inputs.forEach(input => checkFilledInput(input));
                    }
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

export function checkFilledInput(input) {
    let inputGroup = input.closest(".inputGroup");
    let infieldInputGroup = input.closest(".infieldInputGroup");

    function updateInputClasses() {
        let hasValue;
        try {
            hasValue = input.matches(':autofill');
        } catch (err) {
            try {
                hasValue = input.matches(':-webkit-autofill');
            } catch (er) {
                hasValue = false;
            }
        }
        const isFilled = input.value !== "" || hasValue;

        if (inputGroup) {
            isFilled ? inputGroup.classList.add("is-filled") : inputGroup.classList.remove("is-filled");
        }

        if (infieldInputGroup) {
            isFilled ? infieldInputGroup.classList.add("is-filled") : infieldInputGroup.classList.remove("is-filled");
        }

        if (input.dataset.intlTelInputId !== undefined) {
            if (inputGroup) inputGroup.classList.add("is-focus");
            if (infieldInputGroup) infieldInputGroup.classList.add("is-focus");
        }
    }

    updateInputClasses();
    const observer = new MutationObserver(updateInputClasses);
    observer.observe(input, { attributes: true, attributeFilter: ['class', 'autofill'] });

    const intervalId = setInterval(updateInputClasses, 200);

    input.addEventListener('focus', updateInputClasses);

    setTimeout(() => {
        clearInterval(intervalId);
        observer.disconnect();
        input.removeEventListener('focus', updateInputClasses);
    }, 5000);

    return () => {
        clearInterval(intervalId);
        observer.disconnect();
        input.removeEventListener('focus', updateInputClasses);
    };
}